import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { TravelMetadataComponentAbstract } from '../../metadata-components/travel-metadata/travel-metadata.component.abstract';

@Component({
  selector: 'app-travel-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './travel-metadata-v2.component.html',
})
export class TravelMetadataV2Component extends TravelMetadataComponentAbstract {}
